import http from "../utils/http-common";

class BackupService {
    getAll() {
        return http.get("/backups");
    }

    download(filename) {
        return http.get(`/backups/${filename}`, { responseType: 'blob' });
    }

    delete(filename) {
        return http.delete(`/backups/${filename}`);
    }
}

export default new BackupService();
